import { SuccessCircleIcon } from '@/common/icons/general'
import { Button } from '@/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests'
import { LOG_TYPES } from '../constants'

export const ApplicationSent = () => {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: "Application submitted."
      }) 
      hasLoggedPageView.current = true; 
    }
  }, [])

  return (
    <>
      <div className="flex flex-col items-center justify-center mt-6 min-h-[40vh]">
        {/* Check Icon */}
        <SuccessCircleIcon />
        <h3 className="text-xl font-medium text-gray-900 mt-3">
          {translate('application_submitted')}
        </h3>
        <p className="text-sm text-center text-gray-900 mt-6">
          {translate('application_submitted_text')}
        </p>
      </div>
      <div className="text-center h-full flex mt-6">
        <div className="flex justify-end mb-5 w-full flex-col">
          <Button
            onClick={() => {
              navigateTo(AppRoutePaths.home.index)
            }}
            className="rounded h-9 mb-5"
          >
            {translate('continue')}
          </Button>
        </div>
      </div>
    </>
  )
}
